<template>
    <sub-page class="exam-detail">
        <el-row :gutter="20">
            <el-col :span="6">
                <ui-card class="exam-panel exam-info" :title="$t('count.countAnalysis')"
                         icon="nucfont inuc-list-chart">
                    <ul>
                        <li><h3>{{$t('paper.name')}}：</h3>
                            <p>{{examDetail.paperName}}</p></li>
                        <li><h3>{{$t('paper.type')}}：</h3>
                            <p>{{examDetail.paperTypeName}}</p></li>
                    </ul>
                    <ul>
                        <li><h3>{{$t('count.passScore')}}：</h3>
                            <p>{{examDetail.passScore}}</p></li>
                        <li><h3>{{$t('count.passRate')}}：</h3>
                            <p>{{Math.round(examDetail.passRate * 10000) / 100+'%'}}</p>
                        </li>
                        <li><h3>{{$t('count.averageScore')}}：</h3>
                            <p>{{examDetail.averageScore}}</p></li>
                    </ul>
                    <ul>
                        <li><h3>{{$t('count.examPassNum')}}：</h3>
                            <p>{{examDetail.passingCount}}</p></li>
                        <li><h3>{{$t('count.examFailNum')}}：</h3>
                            <p>{{examDetail.failedCount}}</p></li>
                    </ul>
                    <ul>
                        <li><h3>{{$t('count.highest')}}：</h3>
                            <p>{{examDetail.highestScore}}</p></li>
                        <li><h3>{{$t('count.lowest')}}：</h3>
                            <p>{{examDetail.lowestScore}}</p></li>
                    </ul>
                    <ul>
                        <li><h3>{{$t('paper.allowResitTimes')}}：</h3>
                            <p>{{examDetail.resit}}</p></li>
                    </ul>
                </ui-card>
            </el-col>
            <el-col :span="18">
                <ui-card class="exam-panel paper-score-statistic" :title="$t('count.paperScoreStatistic')"
                         icon="nucfont inuc-bar-chart">
                    <div v-for="(item,index) in items" :key="index" style="position: relative">
                        <span class="exam-chart-title">{{item.titleName}}</span>
                        <statistics-upload-top
                            :ref="item.id"
                            :statisticName="item.titleName"
                            :id="item.id"
                            :sourceType="sourceType"
                            :legendName="item.legendName">
                        </statistics-upload-top>
                    </div>
                </ui-card>
            </el-col>
        </el-row>
        <el-row class="topic-wrong-rate" :gutter="20">
            <el-col :span="12">
                <ui-card class="exam-panel" :title="$t('count.wrongRateTitle')" icon="nucfont inuc-menu-assemble">
                    <data-tables :data="examTopicData"
                                 :table-props="tableProps"
                                 :page-size="20"
                                 :pagination-props="{pageSizes: [20, 50, 100, 300, 500],pagerCount: 5}"
                                 header-align="center"
                    >
                        <el-table-column type="index" width="60" align="center">
                        </el-table-column>
                        <el-table-column :label="$t('paper.questionType')" align="center" property="topicTypeName"
                                         sortable width="180">
                            <template slot-scope="scope">
                                <span class="tg-bg" :class="topicTypeBg(scope.row.topicType, '')">{{scope.row.topicTypeName}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-for="(title, index) in examTopicTitles" :prop="title.prop"
                                         :label="title.label"
                                         :key="index"
                                         :width="title.width"
                                         show-overflow-tooltip
                                         sortable="custom"
                                         align="center"
                                         class="table-title">
                        </el-table-column>
                        <el-table-column :label="$t('c.operation')" align="center">
                            <div class="btn-cell" slot-scope="scope">
                                <i class="nucfont inuc-preview"
                                   :title="$t('c.view')"
                                   @click="viewTopic(scope.row.topicID,scope.row.topicType)"></i>
                                <i class="nucfont inuc-edit"
                                   v-if="userInfo.userID==scope.row.userID && !scope.row.isDelete && examDetail.paperType !== 5"
                                   :title="$t('c.edit')"
                                   @click="editTopic(scope.row)"></i>
                            </div>
                        </el-table-column>
                    </data-tables>
                </ui-card>
            </el-col>
            <el-col :span="12">
                <ui-card class="exam-panel" :title="$t('count.knowErrorRateStat')"
                         icon="nucfont inuc-bar-axis">
                    <div  style="position: relative">
                        <statistics-knowledge-rate
                            ref="knowRate"
                            id="knowRate"
                            :legendName="$t('count.wrongRate')">
                        </statistics-knowledge-rate>
                    </div>
                </ui-card>
            </el-col>
        </el-row>

        <el-row>
            <el-col>
                <div class="ibox">
                    <div class="content-header">
                        <div class="header-icon">
                            <i class="nucfont inuc-menu-assemble"></i>
                        </div>
                        <span class="title">{{$t('count.scoreRank')}}</span>
                        <div class="btn-box">
                            <a :href="href" ref="downLoad" id="export-a"></a>
                            <a :href="href2" ref="downLoad" id="export-b"></a>
                            <el-button-group>
                                <el-tooltip v-if="examDetail.paperType==1" class="item" effect="dark" :content="$t('count.exportStuDetail')"
                                            placement="top-start"
                                            :hide-after="1000">
                                    <el-button size="small" class="btn" @click="exportStudentDetail()">
                                        <i class="nucfont inuc-word"></i>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" :content="$t('count.exportTranscript')"
                                            placement="top-start"
                                            :hide-after="1000">
                                    <el-button size="small" class="btn" @click="exportReportCard('ruleCard')">
                                        <i class="nucfont inuc-daochu"></i>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" :content="$t('count.print')"
                                            placement="top-start"
                                            :hide-after="1000">
                                    <el-button size="small" class="btn" @click="printReportCard">
                                        <i class="nucfont inuc-print"></i>
                                    </el-button>
                                </el-tooltip>
                            </el-button-group>
                        </div>
                    </div>
                    <el-row class="content_detail">
                        <el-form :inline="true" size="mini" style="padding: 10px">
                            <el-form-item :label="$t('c.username')+'：'">
                                <el-input v-model="formSearch.userName" :placeholder="$t('tip.trainerName')"
                                          clearable></el-input>
                            </el-form-item>
                            <select-multiple :nameArrays="selectNames"
                                             @getExamStatusVal="getExamStatusVal">
                            </select-multiple>

                            <select-multi-orgs @orgsChange="orgsChange"></select-multi-orgs>

                            <el-form-item>
                                <el-button type="primary" @click="getExamReport" round>{{$t('c.query')}}</el-button>
                            </el-form-item>
                        </el-form>
                        <data-tables :data="studentData"
                                     class="score-table"
                                     :table-props="tableProps"
                                     :current-page.sync="currentPage"
                                     :page-size="20"
                                     :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                                     header-align="center"
                        >
                            <el-table-column type="index" width="40" align="center"></el-table-column>
                            <el-table-column v-for="(title, index) in studentTitles" :prop="title.prop"
                                             :label="title.label"
                                             :key="index"
                                             :width="title.width"
                                             show-overflow-tooltip
                                             sortable="custom"
                                             align="center"
                                             class="table-title">
                            </el-table-column>
                            <el-table-column :label="$t('count.studentStatus')" property="statusName" align="center"
                                             sortable="custom" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span class="tg-bg" :class="topicTypeBg('', scope.row.status)">{{scope.row.statusName}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('c.operation')" align="center" width="80">
                                <div class="btn-cell" slot-scope="scope">
                                    <i class="nucfont inuc-preview"
                                       v-if="scope.row.status==2||scope.row.status==3"
                                       :title="$t('c.view')"
                                       @click="viewPaper(scope.row)"></i>
                                    <span v-else>--</span>
                                    <i class="nucfont inuc-bar-axis"
                                       v-if="scope.row.status==2||scope.row.status==3"
                                       :title="$t('count.knowErrorRateStat')"
                                       @click="knowRateByUser(scope.row)"></i>
                                    <span v-else>--</span>
                                </div>
                            </el-table-column>
                        </data-tables>
                    </el-row>
                </div>
            </el-col>
        </el-row>

        <!-- 雷同率 目前支持理论、CT、DR，不支持职鉴(5) -->
        <el-row class="mt20" v-if="examDetail.paperType && (examDetail.paperType !== 5)">
            <el-col>
                <exam-similar
                    :exam-id="processID"
                    :paper-type="examDetail.paperType"
                ></exam-similar>
            </el-col>
        </el-row>

        <el-dialog :title="$t('count.printReview')" :visible.sync="isPrintCard" :modal-append-to-body="false"
                   width="80%">
            <div id="subOutputRank-print">
                <el-form :model="recordCard" ref="ruleCard" :rules="recordRules" style="width: 300px; margin: auto;">
                    <el-form-item prop="title">
                        <input type="text" v-model="recordCard.title" :placeholder="$t('tip.word')"
                               class="print-title"/>
                    </el-form-item>
                </el-form>
                <h3 style="float: right; margin-bottom: 15px">
                    {{$t('count.exportDate')}}：{{printData?printData.createTime:''}}</h3>
                <table border="1" width="100%" class="print-table">
                    <tr>
                        <td>{{$t('count.ranking')}}</td>
                        <td>{{$t('c.username')}}</td>
                        <td>{{$t('c.account')}}</td>
                        <td>{{$t('c.idNo')}}</td>
                        <td>{{$t('c.belong')}}</td>
                        <td>{{$t('count.rightNum')}}</td>
                        <td>{{$t('count.wrongNum')}}</td>
                        <td>{{$t('c.startTime')}}</td>
                        <td>{{$t('count.submitTime')}}</td>
                        <td>{{$t('count.timeConsume')}}</td>
                        <td>{{$t('paper.totalScore')}}</td>
                    </tr>
                    <tr v-for="(item,index) in printCardData" :key="index" style="text-align: center">
                        <td>{{item.rank}}</td>
                        <td>{{item.userName}}</td>
                        <td>{{item.accountNo}}</td>
                        <td>{{item.jobNo}}</td>
                        <td>{{item.orgName}}</td>
                        <td>{{item.correct}}</td>
                        <td>{{item.wrong}}</td>
                        <td>{{item.startTime||'--'}}</td>
                        <td>{{item.submitTime||'--'}}</td>
                        <td>{{item.useTime}}</td>
                        <td>{{item.score}}</td>
                    </tr>
                    <tr>
                        <td colspan="8" style="background: #ccc">{{$t('count.averageScore')}}</td>
                        <td>{{printData?printData.average:''}}</td>
                    </tr>
                    <tr>
                        <td colspan="8" style="background: #ccc">{{$t('count.passScore')}}</td>
                        <td>{{printData?printData.passScore:''}}</td>
                    </tr>
                    <tr>
                        <td colspan="8" style="background: #ccc">{{$t('count.passRate')}}</td>
                        <td>{{printData?Math.round(printData.passRate * 10000) / 100 +'%':''}}</td>
                    </tr>
                </table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="printReportCardSubmit" size="mini">{{$t('count.print')}}</el-button>
            </div>
        </el-dialog>
        <stats-topic-view :topicInfoVisible="topicInfoVisible" ref="topicView" :topicInfo="topicInfo">
        </stats-topic-view>
        <!--学员个人&#45;&#45;知识点错误率统计-->
        <el-dialog
            :title="$t('count.knowErrorRateStat')"
            :visible.sync="errorDialog"
            custom-class="role-dialog"
            width="650px"
            :modal-append-to-body="false"
            :close-on-click-modal="false">
                <statistics-knowledge-rate
                    ref="knowRateByUser"
                    id="knowRateByUser"
                    :legendName="$t('count.wrongRate')">
                </statistics-knowledge-rate>
        </el-dialog>
        <transition enter-active-class="animated zoomInRight"
                    leave-active-class="animated zoomOutUp">
            <router-view @updateData="query"></router-view>
        </transition>

        <paper-view
            v-if="paperShow"
            :paperInfo="paperInfo"
            :topicData="topicData"
            @close="onPaperClose"
        >
        </paper-view>

        <fiscan-paper
            ref="fiscanPaper"
            v-model="fiscanPaper.show"
            :data="fiscanPaper.data"
            type="exam"
            :usage="2"
        />

        <full-screen
            ref="nstswrap"
            :src="src"
            :isShow="isShow"
            :showCloseBtn="false"
            @changeIsShow="toggleIsShow"
        />
    </sub-page>
</template>

<script>
    import api from '@/api';
    import ExamSimilar from "./Components/ExamSimilar";
    import SubPage from '@components/Subpage.vue';
    import uiCard from '@components/Statistics/StatisticUICard.vue';
    import StatisticsUploadTop from "@components/Statistics/StatisticsUploadTop";
    import StatisticsKnowledgeRate from "@components/Statistics/StatisticsKnowledgeRate";
    import {Ticket, screenfull} from '@/utils';
    import paperView from '@components/Paper/PaperView';
    import FiscanPaper from '@components/FiscanPaper';
    import FullScreen from '@components/FullScreen';
    import SelectMultiple from '@components/Selectmultiple';
    import selectMultiOrgs from '@components/SelectMultiOrgs';
    import StatsTopicView from "@components/Statistics/StatsTopicView";
    import qs from 'qs';

    export default {
        components: {
            ExamSimilar,
            SubPage,
            uiCard,
            StatisticsUploadTop,
            paperView,
            FullScreen,
            SelectMultiple,
            selectMultiOrgs,
            StatsTopicView,
            StatisticsKnowledgeRate,
            FiscanPaper
        },
        data() {
            return {
                processID: this.$route.params.processID,
                examDetail: {
                    paperType: '',
                    paperTypeName: '',
                    paperName: '',
                    passScore: '',
                    passRate: '',
                    averageScore: '',
                    passingCount: '',
                    failedCount: '',
                    highestScore: '',
                    lowestScore: '',
                    resit: 0,
                },
                items: [
                    {
                        titleName: this.$t('count.rankStatisticsTitle'),
                        id: 'score',
                        legendName: this.$t('count.score')
                    },
                    {
                        titleName: this.$t('count.rankRangeTitle'),
                        id: 'scoreRange',
                        legendName: this.$t('count.peopleNum')
                    }
                ],
                sourceType: undefined,
                //考题错误率统计
                examTopicData: [],
                tableProps: {
                    border: true,
                    stripe: true,
                    rowKey: row => row.id,
                    height: "306px"
                },
                examTopicTitles: [{
                    prop: 'number',
                    label: this.$t('c.problemNo')
                }, {
                    prop: 'knowledgeName',
                    label: this.$t('c.knowledgePoint')
                }, {
                    prop: 'wrongRate',
                    label: this.$t('count.wrongRate'),
                    width: '110px'
                }],
                //学员成绩排名
                formSearch: {
                    processID: this.$route.params.processID,
                    userName: undefined,
                    statuses: [],
                    orgIds: []
                },
                studentData: [],
                currentPage: 1,
                studentTitles: [{
                    prop: 'userName',
                    label: this.$t('c.username')
                }, {
                    prop: 'accountNo',
                    label: this.$t('c.account')
                },{
                    prop: 'jobNo',
                    label: this.$t('c.idNo')
                }, {
                    prop: 'orgName',
                    label: this.$t('c.belong')
                }, {
                    prop: 'correct',
                    label: this.$t('count.rightNum')
                }, {
                    prop: 'wrong',
                    label: this.$t('count.wrongNum')
                }, {
                    prop: 'startTime',
                    label: this.$t('c.startTime'),
                    width: '150px'
                }, {
                    prop: 'submitTime',
                    label: this.$t('count.submitTime'),
                    width: '150px'
                }, {
                    prop: 'useTime',
                    label: this.$t('count.timeConsume')
                }, {
                    prop: 'score',
                    label: this.$t('count.score'),
                    width: '110px'
                }],
                selectNames: [
                    {
                        key: "examStatus",
                    }],
                // 导出成绩单
                isReportCard: false,
                recordCard: {
                    title: undefined
                },
                printData: undefined,
                recordRules: {
                    title: [
                        {required: true, message: this.$t('tip.transcriptTitle'), trigger: 'blur'}
                    ]
                },
                href: undefined,
                href2: undefined,
                // 打印成绩单
                isPrintCard: false,
                printCardData: [],
                printTitles: [
                    {
                        prop: 'rank',
                        label: this.$t('count.ranking')
                    }, {
                        prop: 'userName',
                        label: this.$t('c.username')
                    }, {
                        prop: 'accountNo',
                        label: this.$t('c.account')
                    }, {
                        prop: 'orgName',
                        label: this.$t('c.belong')
                    }, {
                        prop: 'correct',
                        label: this.$t('count.rightNum')
                    }, {
                        prop: 'wrong',
                        label: this.$t('count.wrongNum')
                    }, {
                        prop: 'submitTime',
                        label: this.$t('count.submitTime')
                    }, {
                        prop: 'duration',
                        label: this.$t('count.timeConsume')
                    }, {
                        prop: 'score',
                        label: this.$t('paper.totalScore')
                    },],

                isShow: false,
                src: '',
                paperShow: false,
                paperInfo: {},
                topicData: [],
                topicInfoVisible: false,
                topicInfo: {},
                errorDialog:false,

                fiscanPaper: {
                    show: false,
                    data: null,
                },
            }
        },
        created() {
            if (Ticket.get()) {
                this.userInfo = Ticket.get();
            }

            this.getExamDetails();
            this.getScoreRank();
            this.getScoreRange();
            this.getExamReport();
            this.query();
        },
        methods: {
            query(){
                this.getExamTopics();
                this.getExamKnowRate();
            },
            uploadFunction(data, id) {
                // 父组件多次同一个子组件，调用子组件函数时应加上唯一的标识（id）
                this.$refs[id][0].upLoadSeption(data, id);
            },
            getExamDetails() {
                let data = {
                    processID: this.processID
                };
                api.getExamDetailsAsync(data).then(res => {
                    if (res.package) {
                        for (let item in this.examDetail) {
                            this.examDetail[item] = res.package[item]
                        }
                    }
                })
            },
            getScoreRank() {
                //成绩直方图
                let data = {
                    processID: this.processID
                };
                api.getScoreRankAsync(data).then(res => {
                    if (res.package) {
                        this.uploadFunction(res.package, 'score')
                    } else {
                        this.uploadFunction([])
                    }
                })
            },
            //考试知识点错误率统计
            getExamKnowRate() {
                let data = {
                    processID: this.processID
                };
                api.getExamKnowErrorRate(data).then(res => {
                    if (res.package) {
                        this.$refs.knowRate.knowRateOption(res.package, 'knowRate');
                    } else {
                        this.$refs.knowRate.knowRateOption([],'knowRate');
                    }
                })
            },
            getScoreRange() {
                //成绩分布直方图
                let data = {
                    processID: this.processID
                };
                api.getScoreRangeAsync(data).then(res => {
                    if (res.package) {
                        this.uploadFunction(res.package, 'scoreRange')
                    } else {
                        this.uploadFunction([])
                    }
                })
            },
            getExamReport() {
                this.currentPage = 1;
                let data = {...this.formSearch};

                if (data.statuses.indexOf(0) > -1) {
                    delete data.statuses
                } else if (data.statuses.length && data.statuses.indexOf(0) < 0) {
                    data.statuses = data.statuses.map(v => v-1)
                }

                api.getExamReportAsync(data).then(res => {
                    if (res.package) {
                        this.studentData = res.package;
                        if (this.studentData.length > 0) {
                            this.studentData.forEach(ele => {
                                //ele.startTime = ele.startTime && ele.startTime.slice(0,16)
                                //ele.submitTime = ele.submitTime && ele.submitTime.slice(0,16)
                                ele.useTime = Math.floor(ele.duration / 60) + this.$t('count.min') + Math.floor(ele.duration % 60) + this.$t('count.s')
                            })
                        }
                    }
                })
            },
            getExamTopics() {
                let data = {
                    processID: this.processID
                };
                api.getExamTopicsAsync(data).then(res => {
                    if (res.package) {
                        this.examTopicData = res.package
                        if (this.examTopicData.length && this.examTopicData.length > 0) {
                            this.examTopicData.forEach(ele => {
                                ele['wrongRate'] = Math.round(ele.accuracy * 10000) / 100 + '%'
                            })
                        }
                    }
                })
            },
            //导出学员作答详情
            exportStudentDetail() {
                const ticket = Ticket.get().access_token;
                const culture = this.$i18n.locale;
                this.href2 = `${APIURI}/api/Export/word/exam/theory/${this.processID}?access_token=${ticket}&culture=${culture}&ui-culture=${culture}`;
                this.$nextTick(() => {
                    $('#export-b')[0].click();
                });
            },
            //成绩导出
            exportReportCard(formName) {
                const ticket = Ticket.get().access_token;
                const culture = this.$i18n.locale;
                let queryData = {
                    processID: this.processID,
                    title: this.examDetail.paperName,
                    ...this.formSearch,
                    access_token: ticket,
                    culture: culture,
                    'ui-culture': culture
                }

                if (queryData.statuses.indexOf(0) > -1) {
                    delete queryData.statuses
                } else if (queryData.statuses.length && queryData.statuses.indexOf(0) < 0) {
                    queryData.statuses = queryData.statuses.map(v => v-1)
                }

                let queryString = qs.stringify(queryData, {indices: false})

                //this.href = `${APIURI}/api/Export/Excel/ExamReportCard?processID=${this.processID}&title=${this.examDetail.paperName}&access_token=${ticket}&culture=${culture}&ui-culture=${culture}`;
                this.href = `${APIURI}/api/Export/Excel/ExamReportCard?${queryString}`

                this.$nextTick(() => {
                    $('#export-a')[0].click();
                });
            },
            printReportCard() {
                // 打印
                this.isPrintCard = true;
                let data = {
                    processID: this.processID,
                    title: this.examDetail.paperName,
                    ...this.formSearch,
                };

                if (data.statuses.indexOf(0) > -1) {
                    delete data.statuses
                } else if (data.statuses.length && data.statuses.indexOf(0) < 0) {
                    data.statuses = data.statuses.map(v => v-1)
                }

                api.getExamReportCard(data).then(res => {
                    this.recordCard.title = this.examDetail.paperName;

                    this.printData = res.package;
                    this.printCardData = res.package.items;
                    if (this.printCardData.length > 0) {
                        this.printCardData.forEach(ele => {
                            //ele.startTime = ele.startTime && ele.startTime.slice(0,16)
                            //ele.submitTime = ele.submitTime && ele.submitTime.slice(0,16)
                            ele.useTime = Math.floor(ele.duration / 60) + this.$t('count.min') + Math.floor(ele.duration % 60) + this.$t('count.s')
                        })
                    }
                })
            },
            printReportCardSubmit() {
                let title = this.recordCard.title?this.recordCard.title.trim():undefined;
                if (!title) {
                    this.$message.error(this.$t('tip.title'))
                    this.recordCard.title = undefined
                } else {
                    this.dataBind(); // 同步input输入的值
                    let subOutputRankPrint = document.getElementById('subOutputRank-print');
                    let newContent = subOutputRankPrint.innerHTML;
                    let oldContent = document.body.innerHTML;
                    document.body.innerHTML = newContent;
                    window.print();
                    window.location.reload(); //解决打印之后按钮失效的问题
                    document.body.innerHTML = oldContent;
                    return false;
                }
            },
            dataBind() {
                $("input").each(function () {
                    $(this).attr('value', $(this).val().trim());
                });
            },

            viewPaper({testID}) {
                if (this.examDetail.paperType === 1) {
                    screenfull.request();
                    this.paperShow = true;

                    api.examDetail(testID).then(res => {
                        let data = res.package;

                        this.topicData = data.paper.relationship;

                        this.paperInfo = {
                            response: data.records,
                            isSubmit: data.isSubmit,
                            score: data.score,
                            totalSeconds: data.totalSeconds,
                            ...data.paper,
                        };
                    }).catch(error => {
                        this.paperShow = false;
                        screenfull.exit();
                    });
                } else if (this.examDetail.paperType === 3 || this.examDetail.paperType === 4) {
                    this.isShow = !this.isShow;
                    if (this.examDetail.paperType === 4) {
                        this.src = `${api.imagePanoramicHost}/drExamRecord?recordId=${testID}&lang=${this.$i18n.locale}`
                        // this.src = `/static/3D/DR_base.html?type=IMAGE_EXAM&examID=${testID}&examStatus=2`
                    } else {
                        this.src = `${api.imagePanoramicHost}/ctExamRecord?recordId=${testID}&lang=${this.$i18n.locale}`
                        // this.src = `/static/3D/CT_base.html?type=IMAGE_EXAM&examID=${testID}&examStatus=2`
                    }
                    this.$refs.nstswrap.fullScreen()
                }else if (this.examDetail.paperType === 5) {
                    // 职鉴
                    this.fiscanPaper.show = true

                    api.examDetail(testID).then(res => {
                        this.fiscanPaper.data = res.package
                    }).catch(() => {this.fiscanPaper.show = false})
                }
            },
            onPaperClose() {
                this.paperShow = false;
            },
            toggleIsShow(val) {
                this.isShow = val;
                this.src = null;
            },
            getExamStatusVal(data) {
                this.formSearch.statuses = data;
            },
            orgsChange(data) {
                this.formSearch.orgIds = data;
            },
            viewTopicVisible(data) {
                // 父组件多次同一个子组件，调用子组件函数时应加上唯一的标识（id）
                this.$refs['topicView'].topicVisible(data);
            },
            viewTopic(topicID, type) {
                let topicUrl;
                switch (type) {
                    case 5:
                        topicUrl = api.getDrTopicInPaper(topicID);
                        break;
                    case 6:
                        topicUrl = api.getCtTopic(topicID);
                        break;
                    case 8:
                        // 职鉴题
                        topicUrl = api.getFiscanTopicDetail(topicID)
                        break;
                    default:
                        topicUrl = api.getTheoryTopicDetail(topicID);
                        break;
                }
                topicUrl.then(res => {
                    if (res.package) {
                        this.topicInfo = res.package;
                        this.topicInfoVisible = true;
                        this.viewTopicVisible(res.package)
                    }
                })
            },
            editTopic(item) {
                if (item.topicType !== 7) {
                    this.$router.push({name: 'examDetailTopicEdit', params:{id: item.topicID, type: item.topicType}})

                    // 配对题
                } else {
                    this.$router.push({name: 'examDetailGraphicEdit', query: {id: item.topicID}})
                }
            },
            topicTypeBg(type, status) {
                let bgColor = 'blue';
                if (type == 1 || status == 2)
                    bgColor = 'yellow';
                if (type == 2 || status == 0)
                    bgColor = 'blue';
                if (type == 3 || status == 4)
                    bgColor = 'gray';
                if (type == 5 || status == 3)
                    bgColor = 'red';
                if (type == 6 || status == 1)
                    bgColor = 'green';
                return bgColor;
            },
            //学员知识点错误率统计
            knowRateByUser(data){
                this.errorDialog=true;
                let info = {
                    processID: this.processID,
                    userID: data.userID,
                };
                api.getExamKnowErrorRateByUser(info).then(res => {
                    if (res.package) {
                        this.$refs.knowRateByUser.knowRateOption(res.package, 'knowRateByUser');
                    } else {
                        this.$refs.knowRateByUser.knowRateOption([], 'knowRateByUser');
                    }
                })
            }
        },
    }
</script>

<style scoped lang="scss">
    .exam-detail {
        & /deep/ .ibox {
            .content_detail {
                .resource-type {
                    .knowledgeBox {
                        width: 700px;
                        min-width: 700px;
                    }
                }
                .el-select-dropdown__list {
                    min-width: 150px;
                }
            }
        }
        & /deep/ .ui-card {
            border: 1px solid #ebebed;
            box-shadow: none;
            .card-header {
                border-bottom: 1px solid #ebebed;
            }
        }
        .topic-wrong-rate {
            & /deep/ .card-body {
                padding: 0;
            }
            & /deep/ .sc-table {
                thead {
                    tr {
                        th {
                            background: #fff;
                        }
                    }
                }
            }
        }

        @media screen and (max-width: 1366px) {
            .topic-wrong-rate {
                .el-col {
                    float: none;
                    width: 100%;
                }
            }
        }

        @media screen and (max-width: 1280px) {
            .el-col {
                float: none;
                width: 100%;
            }
            .exam-info {
                height: 500px;
            }
            .ibox .content_detail {
                padding: 0;
            }
        }
    }

    .exam-info {
        height: 732px;
        & /deep/ .card-body {
            padding: 0;
        }
    }

    .exam-panel {
        ul {
            width: 100%;
            padding: 0 20px;
            border-bottom: 1px solid #cccdcd;
            li {
                display: flex;
                padding: 15px 0;
                border-bottom: 1px dashed #cccdcd;
                &:last-child {
                    border-bottom: none;
                }
            }
            h3 {
                display: inline-block;
                min-width: 90px;
            }
            p {
                flex: 1;
            }
        }
        ul:last-child {
            border: none;
        }
    }

    .tg-bg {
        color: #fff;
        display: inline-block;
        min-width: 84px;
        text-align: center;
        &.blue {
            background-color: #2e7faa;
        }
        &.green {
            background-color: #0396a6;
        }
        &.gray {
            background-color: #8c7b6c;
        }
        &.yellow {
            background-color: #ffb822;
        }
        &.red {
            background-color: #f4516c;
        }
        &.recover {
            background-color: #c47a76;
        }
    }

    .paper-score-statistic {
        & /deep/ .content-header {
            display: none;
        }
        & /deep/ .ibox {
            box-shadow: none;
            .el-card__body {
                padding: 0 0;
            }
            .content_detail {
                padding: 0;
                .resource-type {
                    .knowledgeBox {
                        height: 290px;
                    }
                    .emptyBox {
                        height: 290px;
                        line-height: 290px;
                    }
                }
            }
        }
        .exam-chart-title {
            display: inline-block;
            margin: 15px 40px 0;
            padding: 2px 5px;
            color: #fff;
            font-size: 14px;
            background: #2f80ad;
            letter-spacing: 1px;
        }
    }

    .ibox {
        background-color: #fff;
        border: 1px solid #ebebed;
        box-shadow: none;
        .content-header {
            height: 40px;
            background: #f4f3f8;
            border-bottom: 1px solid #ebebed;
            .btn-box {
                float: right;
                .btn {
                    background: #f3f6f6;
                    border: none;
                    color: #208acc;
                }
            }
            .header-icon {
                display: inline-block;
                height: 40px;
                width: 45px;
                line-height: 40px;
                text-align: center;
                border-right: 1px solid #ccc;
                box-shadow: 1px 0 0 #fff;
                color: #2e7faa;
                .nucfont {
                    font-size: 20px
                }
            }
            .title {
                height: 40px;
                line-height: 40px;
                padding-left: 10px;
                color: #333;
                font-size: 16px;
            }
        }
        .content_detail {
            padding: 40px 40px 0;
        }
    }

    .score-table {
        margin: 0 -20px;
    }

    .print-title {
        width: 100%;
        border: none;
        text-align: center;
    }

    .print-table {
        td {
            text-align: center;
        }
    }

    .exam-detail {
        > /deep/ .el-main {
            overflow-x: hidden;
        }
    }
</style>
